import { MUIDialog } from "@abb/arcadia-ui-react"
import { useCallback, useState } from "react"

export function useDeleteConfirm() {
  const [pendingDelete, setPendingDelete] = useState<(() => void) | null>(null)

  const requestDelete = useCallback((onConfirm: () => void) => {
    setPendingDelete(() => onConfirm)
  }, [])

  const handleConfirm = useCallback(() => {
    pendingDelete?.()
    setPendingDelete(null)
  }, [pendingDelete])

  const handleClose = useCallback(() => {
    setPendingDelete(null)
  }, [])

  const DeleteConfirmDialog = (
    <MUIDialog
      id="delete-confirm-dialog"
      variant="warning"
      open={pendingDelete !== null}
      onClose={handleClose}
      heading="Are you sure you want to delete this item?"
      primaryButtonText="Delete"
      onClickPrimaryButton={handleConfirm}
      primaryButtonConfig={{
        type: "primary",
        size: 32,
        id: "delete-confirm-btn",
      }}
    />
  )

  return { requestDelete, DeleteConfirmDialog }
}
